import AxiosAPI from '../../../utils/AxiosAPI';

// get services list
export const ApiGetServicesList = () =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// create service
export const ApiCreateService = (formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// Get service details by id
export const ApiGetServiceDetails = (appServiceId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/${appServiceId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// update service
export const ApiUpdateService = (appServiceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/${appServiceId}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// set priority
export const ApiSetPriority = (formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/save-priorities`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// Create package under app service id
export const ApiCreateServicePackage = (appServiceId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/${appServiceId}/package`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    setIsError(data.referenceName);
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// update package under app service id
export const ApiUpdateServicePackage = (appServiceId, packageId, formData) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/${appServiceId}/package/${packageId}`)
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// create pricing under app service id and package id
export const ApiCreateServicePackagePricing = (appServiceId, packageId, formData, setIsError) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/setting/app-service/${appServiceId}/package/${packageId}/pricing`)
            .post(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
// update pricing under app service id and package id
export const ApiUpdateServicePackagePricing = (
    appServiceId,
    packageId,
    pricingId,
    formData,
    setIsError
) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(
                `/api/setting/app-service/${appServiceId}/package/${packageId}/pricing/${pricingId}`
            )
            .put(formData)
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                    setIsError(data.referenceName);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// delete pricing under app service id and package id
export const ApiDeleteServicePackagePricing = (appServiceId, packageId, pricingId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(
                `/api/setting/app-service/${appServiceId}/package/${packageId}/pricing/${pricingId}`
            )
            .delete()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });

// purchase services list by user id
export const ApiGetPurchaseServicesList = (userId) =>
    new Promise((resolve, reject) => {
        AxiosAPI()
            .setPath(`/api/purchase/service-list/${userId}`)
            .get()
            .then(({ data }) => {
                if (data.status === 0) {
                    resolve(data);
                } else {
                    reject(data.title);
                }
            })
            .catch((err) => {
                reject(err);
            });
    });
export default null;
